import Footer from "../../helperComponents/Footer/Footer";
import Header from "../../helperComponents/Header/header";
import PreFooter from "../../helperComponents/PreFooter/Prefooter";
import { useMediaQuery } from "react-responsive";
import './contact.scss';
import { PiInstagramLogoFill } from "react-icons/pi";
import { RiWhatsappFill } from "react-icons/ri";
import { Link } from "react-router-dom";
import { GoArrowUpRight } from "react-icons/go";
import { BiLogoFacebookCircle } from "react-icons/bi";
import { useEffect } from "react";
import SplitType from "split-type";
import gsap from "gsap";


export default function Contact() {
    const isMediumScreen = useMediaQuery({ query: '(max-width: 850px)' });

    useEffect(() => {
        new SplitType('.contact__containerText1');
        const tl1 = gsap.timeline();

        tl1.to(".contact__containerText1", {
            duration: .5,
            y: 0,
            height: "fit-content",// Or an appropriate maximum height
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)", // Animate to full view
            ease: "power4.inOut",
            opacity: 1,
            paddingBottom: '20px',
            stagger: {
                amount: 0.3
            }
        }).to(".char", {
            duration: .7,
            y: 0,
            ease: "power4.inOut",
            stagger: {
                amount: 0.3
            }
        }).to(".contact__containerArrow", {
            duration: .7,
            opacity: 1,
            x: 0,
            ease: "sine.inOut",
            stagger: {
                amount: 0.3
            }
        },'-=.7')


    }, []);

    return (
        <main className="contact__container">
            <Header isHomepage={false} />
            <section className="contact__container__main" style={{ display: 'flex', flexDirection: 'column', gap: isMediumScreen ? '50px' : '70px', alignItems: 'center', padding: isMediumScreen ? '0 16px' : '0 70px', marginTop: isMediumScreen ? '80px' : '150px' }}>
                <section className="contact__container1" style={{ display: 'flex', gap: isMediumScreen ? '50px' : '70px', flexDirection: 'column', alignItems: 'center' }}>
                    <p className="contact__containerText1" style={{ color: '#916859', width: isMediumScreen ? '100%' : '80%', fontWeight: 500, fontSize: isMediumScreen ? '45px' : "100px", lineHeight: isMediumScreen ? '48px' : "110px", textAlign: 'center' }}>Hey, there! <span style={{ width: '100%', fontStyle: 'italic', display: 'block' }}>thinking about working with us?</span></p>
                    <Link className="contact__containerArrow"  to={"mailto:dudusworldent@gmail.com?subject=Inquiry%20About%20Dudu's%20World"} style={{ cursor: 'pointer', width: 'fit-content', fontSize: isMediumScreen ? '15px' : '20px', lineHeight: isMediumScreen ? '22px' : '28px', display: 'flex', gap: '4px', padding: isMediumScreen ? '15px 16px' : '21px 24px', borderRadius: '100px', border: 'solid 1.6px #916859', alignItems: 'center', color: '#916859' }}>
                        <p>Send Us A Message</p>
                        <GoArrowUpRight fontSize={isMediumScreen ? 20 : 24} />
                    </Link>
                </section>
                <section className="contact__container2" style={{ width: '100%', position: 'relative', padding: '8px' }}>
                    <hr style={{ width: '100%' }} />
                    <p style={{ color: '#916859', padding: isMediumScreen ? '8px 16px' : '8px 64px', background: '#FBF4E5', width: 'fit-content', position: 'absolute', right: `calc(50% - ${isMediumScreen ? '16px' : '64px'})`, bottom: '-8px', }}>Or</p>
                </section>
                <section className="contact__container3" style={{ display: 'flex', gap: isMediumScreen ? '24px' : "40px" }}>
                    <Link to={"https://wa.link/kfl8l4"}><RiWhatsappFill fontSize={isMediumScreen ? 28 : 45} color="#916859" cursor={"pointer"} /></Link>
                    <Link to={'https://www.instagram.com/dudus_world_of_ent?igsh=bWsyeGhhdWdobjV4'}><PiInstagramLogoFill fontSize={isMediumScreen ? 28 : 45} color="#916859" cursor={"pointer"} /></Link>
                    <Link to={'https://www.facebook.com/dudusworld1?mibextid=LQQJ4d'}><BiLogoFacebookCircle fontSize={isMediumScreen ? 28 : 45} color="#916859" cursor={"pointer"} /></Link>
                    {/* <Link><RiLinkedinBoxFill fontSize={isMediumScreen? 28 : 45} color="#916859" cursor={"pointer"} /></Link> */}
                </section>
            </section>
            <PreFooter />
            <Footer />
        </main>
    )
}